import Template from 'backbone/platform/templates/assets/media_library_assets_layout.js.hamlc'
import MediaLibraryAssetsCollectionView from 'backbone/platform/views/assets/media_library_assets_collection_view.js'
import AssetsFiltersView from 'backbone/platform/views/assets/assets_filters_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class MediaLibraryAssetsLayoutView extends Backbone.View
  initialize: (options) ->
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.bind("toggleAssetsView", @toggleAssetsView)
    @dispatcher.bind("collectionLoaded", @renderFilters)
    @dispatcher.bind("redactorModalClosed", @remove)
    @dispatcher.bind("searchAssets", @search)
    @options = options

  render: ->
    @_cleanupSubviews()
    @$el.html(Template())

    @subviews = []
    if @options.mediaLibraryAccess
      @collectionView = new MediaLibraryAssetsCollectionView
        el: @$(".js-assets-container")
        brandProfileId: @options.brandProfileId
        clickCallback: @options.clickCallback
        collection: @options.collection
        viewStyle: "tile-view"
      @subviews.push(@collectionView)

    @$(".assets-frame").scroll =>
      @onScroll()

    if @scrollPosition?
      @$(".assets-frame").scrollTop(@scrollPosition)

    this

  renderFilters: (collection) =>
    @subviews = [] unless @subviews?
    @filtersView = new AssetsFiltersView
      collection: collection
      el: @$('.asset-filters')
    @filtersView.render()
    @subviews.push(@filtersView)

  search: (e) =>
    if e.target.id == "query"
      e.preventDefault()
      @filtersView.changeFilters(e)

  toggleAssetsView: (viewStyle) =>
    collection = @collectionView.collection
    @collectionView.remove()

    collectionViewOptions =
      collection: collection
      el: @$(".js-assets-container")
      brandProfileId: @options.brandProfileId
      clickCallback: @options.clickCallback
      viewStyle: viewStyle

    @collectionView =
      new MediaLibraryAssetsCollectionView(
        collectionViewOptions
      )

    @subviews.push(@collectionView)

  onScroll: ->
    @scrollPosition = @$(".assets-frame").scrollTop()

  pickedAssets: ->
    @collectionView?.pickedAssets()

  deselectAll: ->
    @collectionView.collection.deselectAll()

  remove: =>
    @_cleanupSubviews()
    $(document).off("keydown", @search)
    @dispatcher.unbind("toggleAssetsView", @toggleAssetsView)
    @dispatcher.unbind("collectionLoaded", @renderFilters)
    @dispatcher.unbind("redactorModalClosed", @remove)
    @dispatcher.unbind("searchAssets", @search)
    super

  _cleanupSubviews: ->
    if @subviews
      _.each @subviews, (subview) ->
        subview.remove()
      delete @subviews



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/media_library_assets_layout_view.js.coffee